import { render, staticRenderFns } from "./FeaturesSectionBox.vue?vue&type=template&id=0f393edb&scoped=true&"
import script from "./FeaturesSectionBox.vue?vue&type=script&lang=js&"
export * from "./FeaturesSectionBox.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesSectionBox.vue?vue&type=style&index=0&id=0f393edb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f393edb",
  null
  
)

export default component.exports